import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from "dayjs";
import { useSelector } from 'react-redux';
import { selectCurrentCaseCalls, selectCurrentCaseEmails } from '../../../redux/currentCase/selectors';
import { ExternalUpdatesTable } from './ExternalUpdatesTable';
import { Divider } from '@material-ui/core';
const useStyles = makeStyles({

    label: {
        color: "#eeeeee",
        fontWeight:"bold",
        fontSize:"14px",
        marginBottom:"10px",
        marginTop:"0px"
    },
    controlers: {
        width:"100% !important"
    },
    containers: {
        marginBottom:10,
    },
    hideCallTableContainer: {
        display:"none"
    }
  });


  export default function CallTable (props) {
    const classes = useStyles();
    const {showCallTable, contractCalls, contractEmails, handleShowForms} = props;
    const currentCaseCalls = useSelector(selectCurrentCaseCalls);
    const currentCaseEmails = useSelector(selectCurrentCaseEmails);

    const dataCallTable = contractCalls?.length >= currentCaseCalls?.length ? contractCalls : currentCaseCalls;
    const dataEmailTable = contractEmails?.length >= currentCaseEmails?.length ? contractEmails : currentCaseEmails;


    return (
    <div className={showCallTable ? "" : classes.hideCallTableContainer} style={{position:"absolute",top:0,zIndex:1500,left:0,width:"400px",height:"auto",backgroundColor:"#DBE6E0",padding:"15px"}}>
        <div  onClick={() => handleShowForms("callTable")} style={{cursor:"pointer", color:"#3B5158", float: "right"}}>
                <FontAwesomeIcon icon={faTimes} style={{marginRight: 4, marginLeft:4}}/> 
        </div>
        <ExternalUpdatesTable data={dataCallTable} dataKey={"callId"} title={"Chamadas associadas"} noElementsMessage={"Não há chamadas associadas ao caso"} handleShowForms={handleShowForms}/>
        <div style={{marginTop: "10px", marginBottom: "8px"}}><Divider/></div>
        <ExternalUpdatesTable data={dataEmailTable} dataKey={"uuiD"} title={"E-mails associados"} noElementsMessage={"Não há e-mails associados ao caso"} handleShowForms={handleShowForms}/>
    </div>);
 }